import { Elements, PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { ApiRequest, ShowLoader } from 'GlobalFunctions';
import { useSnackbar } from "notistack";
import { useEffect, useState, useRef } from 'react';


const CheckoutForm = (props: any) => {
    const { setPaymentStatus } = props;
    const stripe = useStripe();
    const elements = useElements();
    const hasCheckedRedirect = useRef(false);

    /*=========================================================
    REDIRECT RECOVERY
    When Stripe redirects for 3DS and the user comes back,
    check if the payment succeeded and verify/create the order.
    =========================================================*/
    useEffect(() => {
        if (!stripe || hasCheckedRedirect.current) return;

        const url = new URL(window.location.href);
        const paymentIntentId = url.searchParams.get('payment_intent');
        const clientSecret = url.searchParams.get('payment_intent_client_secret');

        if (paymentIntentId && clientSecret) {
            hasCheckedRedirect.current = true;
            ShowLoader(true);

            stripe.retrievePaymentIntent(clientSecret).then(async ({ paymentIntent }) => {
                if (paymentIntent && paymentIntent.status === 'succeeded') {
                    const cart = JSON.parse(localStorage.getItem('cart') || '{}');

                    await ApiRequest({
                        url: "/payments/verifyStripePayment",
                        method: "post",
                        body: {
                            payment_intent_id: paymentIntentId,
                            cart
                        },
                        setResponse: (response: any) => {
                            setPaymentStatus(response);
                        }
                    });
                } else if (paymentIntent) {
                    setPaymentStatus({ 
                        status: 'error', 
                        message: `Payment status: ${paymentIntent.status}` 
                    });
                }

                // Clean up URL params
                url.searchParams.delete('payment_intent');
                url.searchParams.delete('payment_intent_client_secret');
                url.searchParams.delete('redirect_status');
                window.history.replaceState({}, '', url.toString());

                ShowLoader(false);
            }).catch((err) => {
                console.error('Error verifying redirect payment:', err);
                ShowLoader(false);
            });
        }
    }, [stripe]);
    
    const handleClick = async () => {
        ShowLoader(true);

        if (!stripe || !elements) {
            console.error('Stripe or Elements not loaded.');
            ShowLoader(false);
            return;
        }

        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: window.location.href,
            },
            redirect: 'if_required'
        });

        if (error) {
            setPaymentStatus({ status: 'error', message: error.message || "Payment failed" });
            
        } else if (paymentIntent) {
            if (paymentIntent.status === 'succeeded') {
                const cart = JSON.parse(localStorage.getItem('cart') || '{}');

                await ApiRequest({
                    url: "/payments/defaultCheckout",
                    method: "post",
                    body: {
                        cart,
                        payment_method: 'stripe',
                        paymentIntent
                    },
                    setResponse: (response: any) => {
                        setPaymentStatus(response);
                    }
                });
            } else {
                // console.log('Payment not completed: ', paymentIntent.status);
            }
            
        }

        ShowLoader(false);
    };


    const [cssClassList, setCssClassList] = useState("w-input");
    const [buttonClassList, setButtonClassList] = useState("w-button");

    useEffect(() => {
        const inputElement = document.querySelector('[pc="fname"]');

        if (inputElement) {
            const classList = inputElement.classList.value;
            setCssClassList(classList);
        }

        const buttonElement = document.querySelector('[pc-step="accordion-next"]');
        if (buttonElement) {
            let classList = buttonElement.classList.value;
            classList = classList.replace("is-disabled", "").trim(); // Eliminar "is-disabled"
            setButtonClassList(classList);
        }

    } ,[]);


    return (
        <div>
            <PaymentElement 
                options={{
                    paymentMethodOrder: ['card']
                }}
            />
            <button 
                type="button" 
                className={buttonClassList}
                disabled={!stripe}
                onClick={handleClick}
                style={{ width: '100%', marginTop: '20px' }}
            >
                Place Order
            </button>
        </div>
    );
};

const StripeForm = (props: any) => {

    const appearance = {
        theme: 'flat' as 'stripe' | 'night' | 'flat', 
        labels: 'floating' as 'floating' | 'above',  
        variables: {
            fontFamily: 'Arial, sans-serif',
            spacingUnit: '4px',
            borderRadius: '5px',
        },
        rules: {
            '.Label': {
            },
            '.Input': {
                borderColor: '#ced4da',
            },
            '.Error': {
                color: '#dc3545',
            },
        },
    };
    const { 
        payment_settings: {
            public_key,
            client_secret: clientSecret
        }, 
        setPaymentStatus 
    } = props;


    const stripePromise = loadStripe(public_key);


    return (
        <Elements stripe={stripePromise} options={{ clientSecret, appearance }}>
            <CheckoutForm setPaymentStatus={setPaymentStatus} />
        </Elements>
    );
};

export default StripeForm;
